<template>
  <b-col class="wrap-list-search-page">
    <b-row>
      <b-col  v-for="(data,key) in categorisDataSearch.data" :key="key" cols="12" class="list-item-search-page">
        
        <ListItemSearch
            :id="data.id"
            :isHot="true"
            :isBookmark="true"
            :color="'bg-yellow'"
            :price="data.price"
            :urlImage="data.url_feature_image"
            :title="data.title"
            :province="data.province.name"
            :district="data.district.name"
            :description="data.description"
            :listingPremium="data.listing_premiums"
            :showGoogleAds="data.showGoogleAds"
            :typeAds="categorySelected"
            :listing_attributes_details="data.listing_attributes_details"
            :url="data.url"
            :fav = "parseInt(data.fav) == 0 ? false : true"
            :target="'_blank'"
            :agency_profile_image="data.agency_profile_image"
          />
      </b-col>
    </b-row>
  </b-col>
</template>
<script>
import ListItemSearch from '../../components/listItemSearch/index';
import { mapGetters, mapActions } from "vuex";
export default {
  name: 'searchList',
  components: {
    ListItemSearch
  },
  data() {
    return {
      randomADSSearch: 0
    }
  },
  props:{
    categorySelected:{
      type:String,
      default:''
    }
  },
  computed:{
    ...mapGetters("CategoryController",
    [
      "categorisDataSearch"
    ]),
  },
  


}
</script>
<style lang="scss">
  @import "style";
</style>